import React, { useState, useContext, useEffect } from 'react';
import UserService from 'services/userService';
import SiteService from 'services/siteService';
import Panel from 'components/common/panel/panel';
import { Form, Alert } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import AuthContext from 'contexts/authContext';
import AppContext from 'contexts/appContext';
import { useLocation } from 'hooks/router';
import useForm from 'hooks/form';
import Config from 'utils/config';

import image_logo from 'assets/logos/POSitouchCloud.gif';

export default function LoginPage(props) {
  const { authState, setAuthLoggedIn } = useContext(AuthContext);
  const { setAppLoggedIn } = useContext(AppContext);

  const { setFormRef, submitForm, renderFormValidationMessage } = useForm({ protect: false });

  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (authState.isMobile === true) {
      window.ReactNativeWebView.postMessage('gotologin');
    }
  }, [location]);

  const redirect = () => {
    props.history.push(props.location.state ? props.location.state.from.pathname : '/');
  };

  const handleSubmit = () => {
    setTimeout(submitForm((cancelSubmit) => {
      setLoading(true);

      UserService.API.login(username, password).then((token) => {
        UserService.API.getAccountDetails(token).then((account) => {
          SiteService.API.getUserHierarchyTree(token).then((hierarchyData) => {
            setAuthLoggedIn(token, account.user, account.permissions, hierarchyData);
            setAppLoggedIn();
            redirect();
          });
        }).catch((error) => {
          setLoginError(error.toString());
          setLoading(false);
          cancelSubmit();
        });
      }).catch((error) => {
        if (error?.response?.status === 401) {
          setLoginError('Invalid User Id or Password.');
        }
        else if (error?.response?.data?.message) {
          setLoginError(error.response.data.message);
        }
        else if (error) {
          setLoginError(error.toString());
        }
        else {
          setLoginError('An error occurred');
        }
        setLoading(false);
        cancelSubmit();
      });
    }), 30);
  };

  const renderError = (message) => {
    if (message) {
      return (
        <Alert variant='danger'>
          <Alert.Heading>Error</Alert.Heading>
          {message.replace('Error: ', '')}
        </Alert>
      );
    }
    return null;
  };

  if (authState.isMobile === true) {
    return null;
  }

  return (
    <div className='row justify-content-md-center mx-0 mt-5'>
      <div className='col-md-10 col-lg-8 col-xl-6'>
        <Form ref={setFormRef} noValidate>
          <Panel>
            <Panel.Header className='text-center'>
              <img src={image_logo} alt='POSitouch Cloud' style={{ maxHeight: 150 }} />
              <div className='mt-3'>Login</div>
            </Panel.Header>
            <Panel.Body>
              {renderError(loginError)}
              <Form.Group>
                <Form.Label>User Id</Form.Label>
                <Inputs.Text required placeholder='User Id' description='User Id' value={username} onValueChange={setUsername} autoComplete='username' />
              </Form.Group>
              <Form.Group>
                <Form.Label>Password</Form.Label>
                <Inputs.Password required placeholder='Password' description='Password' value={password} onValueChange={setPassword} onEnterPress={handleSubmit} autoComplete='current-password' />
              </Form.Group>
            </Panel.Body>
            <Panel.Footer>
              {renderFormValidationMessage()}
              <Inputs.Button variant='app' size='lg' block loading={loading} label='Submit' loadingLabel='Logging In...' onClick={handleSubmit} />
            </Panel.Footer>
          </Panel>
        </Form>

        <div className='text-center mb-4'>
          <Inputs.Button variant='hover-default' label='Forgot User Id/Password' href={`${Config.portalURL}/account/ForgotPassword.aspx`} />
        </div>
      </div>
    </div>
  );
}
